import i18n from 'i18n-js';
import api from './ApiHelper';

const ENLocal = "en";
const languages: string[] = [];

// Add future files in the format:
//  key: the local that will be passed in
//  value: the name of the file to load sans .json
const availableLocals: { [key: string]: any } = {
    en: ENLocal
}

const local = async (local: string) => {
    await addLocale(ENLocal);
    if (local !== ENLocal) {
        if (!availableLocals[local]) {
            local = ENLocal;
        } else {
            await addLocale(availableLocals[local]);
        }
    }

    i18n.fallbacks = true;

    i18n.locale = local;
    return i18n;
}

const addLocale = async (local: string) => {
    if (languages.indexOf(local) === -1) {
        const domain = 'https://dly6mpnwbp865.cloudfront.net' ?? '';
        const url = `${domain}/static/${local}.json`;
        let en = await (await api.get(url, false, {
            refresh: true
        })).data;
        if (en) {
            languages.push(local);
            i18n.translations[local] = en;
        }
    }
}

const reset = () => {
    i18n.reset();
    i18n.translations = {};
    languages.length = 0;
}

export default local;
export { reset };